import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProceduresService, ProcedureFormListItem } from '../procedures.service';
import {TdoTableModel} from '../../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {MatTableDataSource} from '@angular/material/table';
import {TdoTableBaseItemModel} from '../../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableComponent} from '../../../../tdo-controls/common/tdo-table/tdo-table.component';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';

export class ProceduresFormData {
  isSingleSelectMode: boolean = false;
}

export interface ProceduresFormResult {
  selectedForms: ProcedureFormListItem[];
}

class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  DFormName: string;
  DFormId: string;
  enumFormCategoryID: string;
  ItemDisplayValue: string;
  Status: string;
  Version: string;
  model: ProcedureFormListItem;

  getActionTooltip(actionName: string): string {
    return '';
  }
}

@Component({
  selector: 'app-procedures-form',
  templateUrl: './procedures-form.component.html',
  styleUrls: ['./procedures-form.component.scss']
})
export class ProceduresFormComponent implements OnInit {
  @ViewChild(TdoTableComponent) table: TdoTableComponent;

  forms: ProcedureFormListItem[] = [];
  tableViewData: TableViewData[];

  tableModel: TdoTableModel;
  dataSource: MatTableDataSource<TableViewData>;
  displayedColumns = ['DFormName', 'ItemDisplayValue', 'Version', 'Status'];
  displayedColumnsLabels = ['Name', 'Category', 'Version', 'Status'];

  formStatusEnums: EnumValidValueItemModel[] = [];

  constructor(public dialogRef: MatDialogRef<ProceduresFormComponent, ProceduresFormResult>,
              private staticDataService: StaticDataService,
              @Inject(MAT_DIALOG_DATA) public data: ProceduresFormData, private snackBar: MatSnackBar,
              private proceduresService: ProceduresService) { }

  async ngOnInit(): Promise<void> {
    this.formStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumDFormBuildStatus');

    try {
      this.proceduresService.getForms().subscribe((data) => {
        this.forms = data;
        this.refreshTableViewData();
      });
    }
    catch (e) {
      console.log(e);
    }
  }

  refreshTableViewData() {
    this.tableViewData = Array.from(this.forms, (_) => {
      const model = new TableViewData();
      model.DFormName = _.DFormName;
      model.ItemDisplayValue = _.ItemDisplayValue;
      const statEnum = this.formStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === _.Status);
      if (statEnum) {
        model.Status = statEnum.ItemDisplayValue;
      }
      model.Version = _.Version;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource<TableViewData>(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'DFormName', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.DFormName.toLowerCase().includes(filter)) {
          return true;
        }
      };
    }
  }

  private showErrorMessage(message: string) {
    this.snackBar.open(message, 'Error', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onAddClick(event): void {
    console.log('Table selections: ' + (this.table.selection.selected as TableViewData[]).length);
    const selections = this.table.selection.selected as TableViewData[];
    const listItems: ProcedureFormListItem[] = Array.from(selections, (_) => {
      return _.model;
    });

    const res: ProceduresFormResult = {
      selectedForms: listItems
    };
    this.dialogRef.close(res);
  }

  onCancelClick(event): void {
    this.dialogRef.close();
  }
}
